/** Default home route after login / OAuth success */
export function homePathForRole(role) {
  return role === 'Admin' ? '/admin' : '/dashboard'
}
